<template>
    <section v-if="data && data.gallery" class="container container margin-both-lg">
        <div class="inner">
            <OwlCarousel :options="options">
                <WpImage 
                    v-for="image in data.gallery" 
                    :image="image"
                    size="large"
                    :key="image.id"
                    class="item"
                    background 
                    cover
                    styledCaption
                    caption/>
            </OwlCarousel>
        </div>
    </section>
</template>

<script>
import WpImage from '@/components/elements/WpImage'
const OwlCarousel = () => import('@/components/elements/OwlCarousel')
import {arrow} from '@/components/../icons';

export default {
    name: 'gallery',
    props : ['data'],
    components: {
        WpImage,
        OwlCarousel
    },
    data(){
        return{
            options:{
                margin: 20,
                items: 1,
                loop: true,
                center: true,
                nav: true,
                navText: [arrow('#00344D'), arrow('#00344D')]
            },
        }
    }
    
}
</script>

<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";
.module-gallery{
    .wp-image-vue .image{
        background-color: $dark;
        border-radius: $blocksRadius
    }
    .wp-image-vue{
        border-radius: $blocksRadius
    }
    .owl-dots{
        display: none;
    }
    .owl-carousel{
        position: relative;
        
        .owl-prev{
            left: -43px;
            
        }
        .owl-next{
            right: -43px;
            svg{
                transform: rotate(180deg)
            }
        }
        .owl-prev, .owl-next{
            position: absolute;
            top: 50%;
            z-index: 20;
            transform: translateY(-60%);
            background: transparent;
            border: none;
            box-shadow: none;
            cursor: pointer;

            svg{
                height: 20px;
                width: 25px;
                path{
                    transition: 0.2s fill ease-in-out;
                    will-change: fill;
                }
            }
            &.disabled{
                opacity: 0.5;
                cursor: default;
                pointer-events: none;
            }
            &:hover{
                svg{
                    path{
                        fill: $darkL;
                    }
                }
            }
        }
        @include mquery($container){
            .owl-prev{
                left: 20px;
                svg{
                    margin-right: 3px;
                }
                 &:after{
                    left: 0px;
                 }
            }
            .owl-next{
                right: 20px;
                svg{
                    margin-right: -2px;
                }
                &:after{
                    left: 2px;
                }
            }
            .owl-prev, .owl-next{
                //background: #fff !important;
                width: 32px;
                height: 100px;
                svg{
                    position: relative;
                    height: 18px;
                    width: 22px;
                    margin-top: 3px;
                    z-index: 3;
                }
                &:after{
                    z-index: 2;
                    content: '';
                    background: #fff;
                    width: 29px;
                    height: 29px;
                    top: 35px;
                    position: absolute;
                    border-radius: $blocksRadius;
                }
            }
        }
    }
}
</style>